import request from "../../utils/request";

const API_ROUTE = `${process.env.REACT_APP_BASE_API}api/v1`;

export async function getGuestMailApi(id, token) {
  return request(`${API_ROUTE}/users/${id}?token=${token}`, {
    method: "GET",
  });
}
export async function getGuestApi(id) {
  return request(`${API_ROUTE}/users/${id}`, {
    method: "GET",
  });
}
export async function getGuestsApi() {
  return request(`${API_ROUTE}/users`, {
    method: "GET",
  });
}
export async function confirmGuestBySponsorApi(id) {
  return request(`${API_ROUTE}/users/validate/${id}`, {
    method: "PUT",
  });
}
export async function confirmGuestByGuestApi(id, token) {
  return request(`${API_ROUTE}/users/validate/${id}?token=${token}`, {
    method: "PUT",
  });
}
export async function confirmSponsorApi(id, body) {
  return request(`${API_ROUTE}/users/${id}`, {
    method: "PUT",
    data: body,
  });
}
export async function confirmGuestApi(id, token, body) {
  return request(`${API_ROUTE}/users/${id}?token=${token}`, {
    method: "PUT",
    data: body,
  });
}
export async function addGuestByGuestApi(body) {
  return request(`${API_ROUTE}/users`, {
    method: "POST",
    data: body,
  });
}
export async function addGuestBySponsorApi(body) {
  return request(`${API_ROUTE}/users`, {
    method: "POST",
    data: body,
  });
}
export async function addEventApi(body) {
  return request(`${API_ROUTE}/users/event`, {
    method: "POST",
    data: body,
  });
}

export async function getUsersApi() {
  return request(`${API_ROUTE}/users`, {
    method: "GET",
    params: {
      sort: "_id|-1",
    },
  });
}

export async function addUserApi(body) {
  return request(`${API_ROUTE}/users`, {
    method: "POST",
    data: body,
  });
}

export async function deleteUserApi(id) {
  return request(`${API_ROUTE}/users/${id}`, {
    method: "DELETE",
  });
}

export async function editUserApi(id, body) {
  return request(`${API_ROUTE}/users/${id}`, {
    method: "PUT",
    data: body,
  });
}
